var render, staticRenderFns
import script from "./VirtualTableRow.vue?vue&type=script&lang=js"
export * from "./VirtualTableRow.vue?vue&type=script&lang=js"
import style0 from "./VirtualTableRow.vue?vue&type=style&index=0&id=2afccf94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afccf94",
  null
  
)

export default component.exports